import { render, staticRenderFns } from "./PresumptiveReferral.vue?vue&type=template&id=74becb43"
import script from "./PresumptiveReferral.vue?vue&type=script&lang=js"
export * from "./PresumptiveReferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports